import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  createViewerRequest: ['data'],
  createViewerRequestSuccess: null,
  createViewerRequestFailure: ['error'],
  clearCreateStatus: null,
  fetchViewerRequests: ['options'],
  fetchViewerRequestsSuccess: ['data'],
  fetchViewerRequestsFailure: ['error'],
})

export const ViewerRequestTypes = Types
export const ViewerRequestActions = Creators

const INITIAL_STATE = {
  creating: false,
  fetching: false,
  viewerRequests: null,
  createSuccess: null,
  error: null,
}

const createRequest = (state) => ({
  ...state,
  creating: true,
  createSuccess: null,
  error: null,
})

const createSuccess = (state) => ({
  ...state,
  creating: false,
  createSuccess: true,
})

const createFailure = (state, action) => ({
  ...state,
  creating: false,
  error: action.error,
})

const clearCreateStatus = (state) => ({
  ...state,
  creating: false,
  createSuccess: null,
  error: null,
})

const fetchRequest = (state) => ({
  ...state,
  fetching: true,
  error: null,
})

const fetchSuccess = (state, action) => ({
  ...state,
  fetching: false,
  viewerRequests: action.data,
})

const fetchFailure = (state) => ({
  ...state,
  fetching: false,
})

export default createReducer(INITIAL_STATE, {
  [Types.CREATE_VIEWER_REQUEST]: createRequest,
  [Types.CREATE_VIEWER_REQUEST_SUCCESS]: createSuccess,
  [Types.CREATE_VIEWER_REQUEST_FAILURE]: createFailure,
  [Types.CLEAR_CREATE_STATUS]: clearCreateStatus,
  [Types.FETCH_VIEWER_REQUESTS]: fetchRequest,
  [Types.FETCH_VIEWER_REQUESTS_SUCCESS]: fetchSuccess,
  [Types.FETCH_VIEWER_REQUESTS_FAILURE]: fetchFailure,
})
